import * as Redux from 'redux';
import { IActionCreator } from '../../../interfaces/IActionCreator';
import { Keys } from './types';
import { Keys as Keys2 } from '../../medicalExaminations/actions/types';
import { invokeApi } from '../../../networking/invoker';
import { subscription, emptySubscription } from '../../../../model/subscription';
import { contactInsurance, contactMedicalExamination, contactSubscription } from '../../../../model/contactsubscription';
import { forcedAccess } from '../../../../model/access';

export interface IActions {
    searchSubscriptions: (textSearch?: string, subscriptionType?: string, subscriptionState?: string) => void;
    loadSubscription: (id: string) => void;
    saveSubscription: (subscription: subscription) => void;
    addSubscription: (subscription: subscription) => void;
    newSubscription: () => void;
    loadContactPurchased: (userid: string, medical: boolean, subscription: boolean, insurance: boolean) => void;
    clearContactPurchased: () => void;
    saveContactSubscription: (userid: string, subscription: contactSubscription) => void;
    removeAccessContactSubscription: (userid: string, subscription: contactSubscription) => void;
    deleteContactSubscription: (userid: string, subscription: contactSubscription) => void;
    addContactSubscription: (userid: string, subscription: contactSubscription) => void;
    saveAccessInfo: (result: forcedAccess) => void;
    // MEDICAL
    saveContactMedical: (userid: string, medicalExamination: contactMedicalExamination) => void;
    deleteContactMedical: (userid: string, medicalExamination: contactMedicalExamination) => void;
    addContactMedical: (userid: string, medicalExamination: contactMedicalExamination) => void;
    // INSURANCE
    saveContactInsurance: (userid: string, insurance: contactInsurance) => void;
    addContactInsurance: (userid: string, insurance: contactInsurance) => void;
    deleteContactInsurance: (userid: string, insurance: contactInsurance) => void;
}

function parseQueryStringParameters(textSearch?: string, subscriptionType?: string, subscriptionState?: string) {
    let parsed = ``
    if (textSearch || subscriptionType || subscriptionState) {
        parsed = parsed.concat(`?`);
        parsed = parsed.concat(`subscriptionState=${subscriptionState}`);
        if (textSearch) {
            if (parsed.length > 1) {
                parsed = parsed.concat(`&`);
            }
            parsed = parsed.concat(`textSearch=${textSearch}`);
        }
        if (subscriptionType) {
            if (parsed.length > 1) {
                parsed = parsed.concat(`&`);
            }
            parsed = parsed.concat(`subscriptionType=${subscriptionType}`);
        }
    }
    return parsed;
}

export const actionCreator: IActionCreator<IActions> = (dispatch: Redux.Dispatch<any>): IActions => {
    return {
        clearContactPurchased: () => {
            return dispatch({
                type: Keys.CLEARPURCHASED
            })
        },
        // [Route("api/Contacts/{sub}/Subscriptions")]
        // public ActionResult<IEnumerable<UserSubscription>> Get(string sub) - GET
        // public IActionResult Add(string sub, [FromBody] UserSubscription subscription) - POST
        // public IActionResult Update(string sub, [FromBody] UserSubscription subscription) - PUT
        loadContactPurchased: (userid: string, medical: boolean, subscription: boolean, insurance: boolean) => {

            let api = `/api/Contact/${userid}/Purchased/expiring`;

            if (medical === true || subscription === true || insurance === true) {
                // filtered/{medical}/{subscription}/{insurance}
                let sMedical = (medical === true ? "all" : "none");
                let sSubscription = (subscription === true ? "all" : "none");
                let sInsurance = (insurance === true ? "all" : "none");
                api = `/api/Contact/${userid}/Purchased/filtered/${sMedical}/${sSubscription}/${sInsurance}`;
            }
            dispatch({
                type: Keys.LOADCONTACTPURCHASED,
                payload: invokeApi({
                    path: api,
                    method: 'GET',
                    responseType: 'json'
                })
            });
        },
        saveContactSubscription: (userid: string, subscription: contactSubscription) => {
            return dispatch({
                type: Keys.SAVECONTACTSUBSCRIPTION,
                payload: invokeApi({
                    path: `/api/Contact/${userid}/Subscriptions`,
                    method: 'PUT',
                    body: subscription,
                    responseType: 'json'
                })
            })
        },
        removeAccessContactSubscription: (userid: string, subscription: contactSubscription) => {
            return dispatch({
                type: Keys.REMOVEACCESSCONTACTSUBSCRIPTION,
                payload: invokeApi({
                    path: `/api/Contact/${userid}/Subscriptions/RemoveAccess`,
                    method: 'PUT',
                    body: subscription,
                    responseType: 'json'
                })
            })
        },
        deleteContactSubscription: (userid: string, subscription: contactSubscription) => {
            return dispatch({
                type: Keys.DELETECONTACTSUBSCRIPTION,
                payload: invokeApi({
                    path: `/api/Contact/${userid}/Subscriptions`,
                    method: 'DELETE',
                    body: subscription,
                    responseType: 'json'
                })
            })
        },
        saveAccessInfo: (_body: forcedAccess) => {
            invokeApi({
                path: '/api/Access/forceaccess',
                method: 'PUT',
                body: _body,
                responseType: 'json'
            })
        },
        addContactSubscription: (userid: string, subscription: contactSubscription) => {
            return dispatch({
                type: Keys.ADDCONTACTSUBSCRIPTION,
                payload: invokeApi({
                    path: `/api/Contact/${userid}/Subscriptions`,
                    method: 'POST',
                    body: subscription,
                    responseType: 'json'
                })
            })
        },
        deleteContactMedical: (userid: string, medical: contactMedicalExamination) => {
            dispatch({
                type: Keys.DELETECONTACTMEDICAL,
                payload: invokeApi({
                    path: `/api/Contact/${userid}/MedicalExamination`,
                    method: 'DELETE',
                    body: medical,
                    responseType: 'json'
                })
            });
        },
        saveContactMedical: (userid: string, medical: contactMedicalExamination) => {
            return dispatch({
                type: Keys.SAVECONTACTMEDICAL,
                payload: invokeApi({
                    path: `/api/Contact/${userid}/MedicalExamination`,
                    method: 'PUT',
                    body: medical,
                    responseType: 'json'
                })
            })
        },
        addContactMedical: (userid: string, subscription: contactMedicalExamination) => {
            // dispatch per fare reset del nuovo medical examination document

            dispatch({
                type: Keys2.RESETNEW,
            })

            return dispatch({
                type: Keys.ADDCONTACTMEDICAL,
                payload: invokeApi({
                    path: `/api/Contact/${userid}/MedicalExamination`,
                    method: 'POST',
                    body: subscription,
                    responseType: 'json'
                })
            })
        },
        deleteContactInsurance: (userid: string, insurance: contactInsurance) => {
            dispatch({
                type: Keys.DELETECONTACTINSURANCE,
                payload: invokeApi({
                    path: `/api/Contact/${userid}/Insurance`,
                    method: 'DELETE',
                    body: insurance,
                    responseType: 'json'
                })
            });
        },
        saveContactInsurance: (userid: string, insurance: contactInsurance) => {
            return dispatch({
                type: Keys.SAVECONTACTINSURANCE,
                payload: invokeApi({
                    path: `/api/Contact/${userid}/Insurance`,
                    method: 'PUT',
                    body: insurance,
                    responseType: 'json'
                })
            })
        },
        addContactInsurance: (userid: string, insurance: contactInsurance) => {
            return dispatch({
                type: Keys.ADDCONTACTINSURANCE,
                payload: invokeApi({
                    path: `/api/Contact/${userid}/Insurance`,
                    method: 'POST',
                    body: insurance,
                    responseType: 'json'
                })
            })
        },
        searchSubscriptions: (textSearch?: string, subscriptionType?: string, subscriptionState?: string) => {
            dispatch({
                type: Keys.LOADSUBSCRIPTIONS,
                payload: invokeApi({
                    path: `/api/Subscriptions${parseQueryStringParameters(textSearch, subscriptionType, subscriptionState)}`,
                    method: 'GET',
                    responseType: 'json'
                })
            });
        },
        loadSubscription: (id: string) => {
            dispatch({
                type: Keys.LOADSUBSCRIPTION,
                payload: invokeApi({
                    path: `/api/Subscriptions/${id}`,
                    method: 'GET',
                    responseType: 'json'
                })
            })
        },
        addSubscription: (subscription: subscription) => {
            return dispatch({
                type: Keys.ADDSUBSCRIPTION,
                payload: invokeApi({
                    path: `/api/Subscriptions`,
                    method: 'POST',
                    body: subscription,
                    responseType: 'json'
                })
            })
        },
        saveSubscription: (subscription: subscription) => {
            return dispatch({
                type: Keys.SAVESUBSCRIPTION,
                payload: invokeApi({
                    path: `/api/Subscriptions`,
                    method: 'PUT',
                    body: subscription,
                    responseType: 'json'
                })
            })
        },
        newSubscription: () => {
            return dispatch({
                type: Keys.NEWSUBSCRIPTION,
                payload: emptySubscription(),
            })
        },
    }
}